import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { CreateGebiedLabelButton } from '../../../label/components/CreateGebiedLabelButton'
import { GebiedLabels } from '../../../label/components/GebiedLabels'
import { gebiedenVanVerantwoordelijke } from '../../../projectbetrokkene/util/projectbetrokkene-util'
import { StyledError } from '../../../theme/components/StyledError'
import { useLabelsSearch } from '../hooks/useLabelsSearch'
import { useProjectbetrokkenenSearch } from '../hooks/useProjectbetrokkenenSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { ContractinstellingenLabels }

type Props = {
  filters: ContractinstellingenSearchFilters
}

const ContractinstellingenLabels = ({ filters }: Props) => {
  const user = useAuthenticatedUser()
  const {
    data: { items: projectbetrokkenen },
  } = useProjectbetrokkenenSearch({ externalFilters: filters })
  const {
    data: { items: labels },
    isLoading,
    error,
  } = useLabelsSearch({ externalFilters: filters })

  const { combi } = filters

  return (
    <>
      <StyledError error={error} />

      {isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {combi && (
        <CreateGebiedLabelButton
          user={user}
          projectType="Aanvraag"
          verantwoordelijke={combi}
          gebieden={gebiedenVanVerantwoordelijke(projectbetrokkenen)}
        />
      )}

      <GebiedLabels user={user} labels={labels} />

      {!isLoading && labels.length === 0 && (
        <Typography>Selecteer filters om te zoeken.</Typography>
      )}
    </>
  )
}
